import { useEffect, useRef } from 'react';
import { useEffectOnce } from 'react-use';
import { playSound, Sound } from '~/assets/sounds';
import { rage, useObservable } from '~/rage';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { setSelectedIndex } from '../../redux/slices/vehicleSelectionSlice';
import { VehicleCard, VehicleCardContainer } from '../VehicleCard';

const VehicleList = (props: React.HTMLAttributes<HTMLDivElement>) => {
	const shopVehicles =
		useObservable(rage.vehicleShop.getShopInfo())?.vehicles || [];
	const selectedIndex = useLayoutSelector(
		(state) => state.vehicleSelection.selectedIndex,
	);
	const dispatch = useLayoutDispatch();

	const containerRef = useRef<HTMLDivElement | null>(null);

	const mouseScroll = (e: WheelEvent) => {
		e.preventDefault();
		(containerRef?.current as any).scrollLeft += e.deltaY;
	};

	useEffect(() => {
		if (!containerRef?.current) {
			return;
		}

		(containerRef?.current as any)?.addEventListener('wheel', mouseScroll);

		return () => {
			(containerRef?.current as any)?.removeEventListener('wheel', mouseScroll);
		};
	}, [containerRef?.current]);

	useEffect(() => {
		// Автоскролл к выбранному
		setTimeout(() => {
			const vehicleDiv = document.getElementById(
				`vehicleCard#${selectedIndex}`,
			);
			if (vehicleDiv !== null) {
				vehicleDiv.scrollIntoView({ behavior: 'auto', inline: 'center' });
			}
		}, 50);
	}, [selectedIndex]);

	useEffectOnce(() => {
		const preventArrowScroll = (e: KeyboardEvent) => {
			if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
				e.preventDefault();
			}
		};

		document.addEventListener('keydown', preventArrowScroll);
		return () => document.removeEventListener('keydown', preventArrowScroll);
	});

	return (
		<VehicleCardContainer {...props} ref={containerRef}>
			{shopVehicles.map((vehicle, index) => (
				<VehicleCard
					id={`vehicleCard#${index}`}
					key={`card#${index}`}
					data={vehicle}
					selected={selectedIndex === index}
					onClick={() => {
						dispatch(setSelectedIndex(index));
						playSound(Sound.ClickButton);
					}}
				/>
			))}
		</VehicleCardContainer>
	);
};

export { VehicleList };
